import { AUDIT } from "../constants";

const initialState = {
  entries: [],
  total: 0,
  isLoadingGetAudit: false,
  error: null,
};

const auditReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case AUDIT.GET_AUDIT:
      return { ...state, isLoadingGetAudit: true };
    case AUDIT.GET_AUDIT_FAILURE:
      return { ...state, isLoadingGetAudit: false, error: action.payload };
    case AUDIT.GET_AUDIT_SUCCESS:
      return {
        ...state,
        isLoadingGetAudit: false,
        entries: action.payload.data,
        total: action.payload.total,
        error: null,
      };
    default:
      return state;
  }
};

export default auditReducer;
